module.exports = __webpack_public_path__ + "static/media/Fiddlesticks_0.05a6795e.jpg";